import { useState, useEffect, useRef, ChangeEvent } from "react";
import Layout from "../../../../Reusable/Tutor/Layout";
import DetailClasses from "./details.module.scss";
import Swal from "sweetalert2";
import { Services } from "../../../../Service/service";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Error, Success } from "../../../../Reusable/utils/Toast";
import Moment from "react-moment";
import SkeletonLoad from "./SkeletonLoad/skeleton";
import swal from "sweetalert";
import Loader from "../../../../Reusable/Common/LoadingComponents/loader/loader";
import { useNavigate } from "react-router-dom";

const renderLastCompleted = (item: any) => {
    if (!item) return "-";
    let completedStr = "";

    if (item.LastCompletedFileNumber) {
        let lastCompleted = item.LastCompletedFileNumber;
        if (typeof lastCompleted === "string") {
            try {
                const parsed = JSON.parse(lastCompleted);
                if (Array.isArray(parsed)) {
                    completedStr = parsed.join(", ");
                } else if (parsed !== null && parsed !== undefined) {
                    completedStr = String(parsed);
                }
            } catch (e) {
                let clean = lastCompleted.trim();
                if (clean.startsWith("[") && clean.endsWith("]")) {
                    clean = clean.slice(1, -1).trim();
                }
                completedStr = clean;
            }
        } else if (Array.isArray(lastCompleted)) {
            completedStr = lastCompleted.join(", ");
        } else {
            completedStr = String(lastCompleted);
        }
    }

    let partialStr = "";
    if (item.LastFileNumber) {
        let lastFile = item.LastFileNumber;
        let parsedFile: any = null;
        if (typeof lastFile === "string") {
            try {
                parsedFile = JSON.parse(lastFile);
            } catch (e) {
                // Failed to parse
            }
        } else if (typeof lastFile === "object") {
            parsedFile = lastFile;
        }

        if (parsedFile) {
            const isPartiallyCompleted = parsedFile.IsPartiallyCompleted;
            if (isPartiallyCompleted !== 0 && isPartiallyCompleted !== "0" && isPartiallyCompleted !== false) {
                const lessonPlan = parsedFile.LessonPlan;
                const slide = parsedFile.Slide;
                if (lessonPlan !== undefined && lessonPlan !== null && lessonPlan !== "") {
                    partialStr = String(lessonPlan);
                    if (slide !== undefined && slide !== null && slide !== "") {
                        partialStr += `(${slide})`;
                    }
                } else if (slide !== undefined && slide !== null && slide !== "") {
                    partialStr = `(${slide})`;
                }
            }
        }
    }

    if (completedStr && partialStr) {
        return `${completedStr} ${partialStr}`;
    }
    return completedStr || partialStr || "-";
};

function Details() {
    const Navigate = useNavigate();
    const [params] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);
    const [activeTab, setActiveTab] = useState<number>(1);
    let TutorDetails: any = localStorage.getItem("LoginDetails");
    const [data, setData] = useState<any>();
    const [scheduleClasses, setScheduleClasses] = useState([]);
    const [page, setPage] = useState<number>(1);
    const [pagination, setPagination] = useState<any>(null);
    const [scheduleClassesLoad, setScheduleClassesLoad] = useState<boolean>(false);
    const [attendanceLoad, setAttendanceLoad] = useState<boolean>(false);
    const tabsRef = useRef<HTMLDivElement>(null);
    const token = {
        Authorization: `token ${localStorage.getItem("learn2readToken")}`,
    };

    // INITIAL RENDER
    useEffect(() => {
        Get_Details(params.get("batchid"));
    }, []);

    useEffect(() => {
        setPage(1); // Reset page on tab change
    }, [activeTab]);

    useEffect(() => {
        Get_ScheduledClasses(params.get("batchid"), activeTab, page);
    }, [activeTab, page]);

    async function Get_ScheduledClasses(id: string | null, status: number, page: number) {
        setScheduleClassesLoad(true);
        try {
            const response = await Services.classesByBatchId(
                "GET",
                null,
                token,
                id,
                status,
                page,
                20
            );
            setScheduleClassesLoad(false);
            if (response.Status === 1) {
                setScheduleClasses(response.ScheduleClasess || response.ScheduleClasses || []);
                setPagination(response.Pagination || null);
            } else {
                setScheduleClasses([]);
                setPagination(null);
            }
        } catch (err: any) {
            console.log(err);
            setScheduleClassesLoad(false);
        }
    }

    // GET SCHEDULE CLASS DETAILS
    async function Get_Details(id: string | null) {
        setLoading(true);
        try {
            const response1 = await Services.getBatchRequestsDetailsByBatchId(
                "GET",
                null,
                token,
                id
            );
            if (response1.Status === 1) {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                setData(response1.Batches);
            }
        } catch (err: any) {
            console.log(err);
            setLoading(false);
            Error("something went wrong please try again");
        }
    }
    // API CALL FOR APPROVE REJECT ACTION BUTTONS
    async function ApproveRejectRequest(
        RequestId: number,
        BatchID: number | string,
        IsAccepted: number,
        BatchCreatedBy: string,
        BatchName: string,
        BatchType: string
    ) {
        try {
            if (TutorDetails) {
                TutorDetails = JSON.parse(TutorDetails);
            }
            let loginDetails: any = localStorage.getItem("LoginDetails");
            if (loginDetails && loginDetails.length > 0) {
                loginDetails = JSON.parse(loginDetails);
            }
            let RMS = [
                loginDetails?.Lead_RM,
                loginDetails?.Buddy_RM,
                loginDetails?.SecondShift_RM_Morning,
                loginDetails?.SecondShift_RM_Evening,
            ];
            const Response = await Services.ApproveRejectBatchRequests(
                "PUT",
                JSON.stringify({
                    BatchID,
                    IsAccepted,
                    BatchCreatedBy,
                    TutoRms: RMS.filter((item) => item != 0),
                    BatchName,
                    TutorName: `${TutorDetails?.FirstName} ${TutorDetails?.LastName}`,
                    BatcBatchCreatedByType: BatchType,
                    CourseName: data.CourseName,
                }),
                token,
                RequestId
            );

            if (Response.Status === 1) {
                Success(Response.Message);
                Get_Details(params.get("batchid"));
            } else {
                swal("Oops...", Response.Message, "error");
                Error("Some thing went wrong try again");
            }
        } catch (err: any) {
            console.log(err);
            setLoading(false);
            Error("something went wrong please try again");
        }
    }

    const Warning = (e: any, type: number) => {
        let Message;
        let RequestId = Number(params.get("requestId"));
        let batchIdRaw = e.currentTarget.getAttribute("custom-batchId");
        let BatchId = (batchIdRaw && !isNaN(Number(batchIdRaw))) ? Number(batchIdRaw) : (batchIdRaw || "");
        let BatchName = e.currentTarget.getAttribute("custom-batchname");
        let BatchType = e.currentTarget.getAttribute("custom-type");
        let BatchCreatedBy = String(
            e.currentTarget.getAttribute("custom-createBy")
        );

        if (type == 1) {
            // Approve==1,reject==2

            Message = "Are you sure you want to Approve ";
        } else {
            Message = "Are You Sure You want to Reject the Batch?";
        }

        Swal.fire({
            title: Message,
            showDenyButton: true,
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "Yes",
            denyButtonText: "No",
            customClass: {
                actions: DetailClasses["popup-actions"],
                cancelButton: "order-1 right-gap",
                confirmButton: DetailClasses["logout-popup"],
                denyButton: "order-3",
            },
        }).then((result: any) => {
            if (result.isConfirmed) {
                ApproveRejectRequest(
                    RequestId,
                    BatchId,
                    type,
                    BatchCreatedBy,
                    BatchName,
                    BatchType
                );
            }
        });
    };

    const backButton = () => {
        Navigate(-1);
    };
    return (
        <Layout Active={"Batch Request"}>
            {attendanceLoad && (
                <div className={DetailClasses["loader"]}>
                    <Loader />
                </div>
            )}

            <Helmet>
                <meta charSet="utf-8" />
                <title>Batch Request</title>
            </Helmet>
            <div className={DetailClasses["Container"]}>
                <button className={DetailClasses["back"]} onClick={backButton}>
                    Back
                </button>
                <div className={DetailClasses["wrapper"]}>
                    {loading ? (
                        <SkeletonLoad />
                    ) : (
                        <div className={DetailClasses["container"]}>
                            <div className={DetailClasses["header"]}>
                                <h3>
                                    <span></span>Batch Name:{data?.BatchName}
                                </h3>

                                <div className={DetailClasses["action-btns"]}>
                                    {data?.IsTutorAccepted === 1 ? (
                                        <p
                                            className={
                                                DetailClasses["approved"]
                                            }>
                                            Approved
                                        </p>
                                    ) : data?.IsTutorAccepted == 2 ? (
                                        <p className={DetailClasses["reject"]}>
                                            Rejected
                                        </p>
                                    ) : (
                                        <>
                                            <button
                                                custom-batchId={data.BatchID}
                                                custom-createBy={
                                                    data.BatchCreatedBy
                                                }
                                                custom-batchname={
                                                    data.BatchName
                                                }
                                                custom-type={
                                                    data.BatchCreatedByType
                                                }
                                                onClick={(e) => Warning(e, 1)}>
                                                Approve
                                            </button>
                                            <button
                                                custom-batchId={data.BatchID}
                                                custom-createBy={
                                                    data.BatchCreatedBy
                                                }
                                                custom-batchname={
                                                    data.BatchName
                                                }
                                                custom-type={
                                                    data.BatchCreatedByType
                                                }
                                                onClick={(e) => Warning(e, 2)}>
                                                Reject
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className={DetailClasses["profile"]}>
                                <div className={DetailClasses["internal"]}>
                                    <h3>Batch Details</h3>

                                    <div>
                                        <h3>Batch RM</h3>
                                        <p>{data?.BatchRMName}</p>
                                    </div>
                                    <div>
                                        <h3>Course</h3>
                                        <p>{data?.CourseName}</p>
                                    </div>

                                    <div>
                                        <h3>Batch Size</h3>
                                        <p>{data?.BatchSize} </p>
                                    </div>
                                    <div>
                                        <h3>Days</h3>
                                        <p>
                                            {data?.Days?.map((item: any) => {
                                                return (
                                                    <>
                                                        {/* <Moment format="HH:MM ">
                                                        </Moment> */}
                                                        {item.Time},{item.day}
                                                        <br />
                                                    </>
                                                );
                                            })}
                                        </p>
                                    </div>
                                    <div>
                                        <h3>Duration</h3>
                                        <p>{data?.Duration} Min </p>
                                    </div>

                                    {/* <div>
                                        <h3>Lesson Plan</h3>
                                        <p>{data?.TutorLessonPlan} </p>
                                    </div> */}
                                    <div>
                                        <h3>Start Date:</h3>
                                        <p>
                                            <Moment format="DD-MM-YYYY">
                                                {new Date(data?.StartDate)}
                                            </Moment>
                                        </p>
                                    </div>
                                    <div>
                                        <h3>Start Time:</h3>
                                        <p>{data.Time}</p>
                                    </div>
                                    <div>
                                        <h3>Last Marked File Number:</h3>
                                        <p>{renderLastCompleted(data)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className={DetailClasses["internal"]}>
                                <h3>Tutor Instructions</h3>

                                <p>{data?.TutorInstructions}</p>
                            </div>
                            <div className={DetailClasses["Table"]}>
                                <h3>Student Details</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Parent Name</th>
                                            <th>Student Name</th>

                                            {/* <th>Status</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.Students &&
                                            data?.Students?.length > 0 &&
                                            data?.Students?.map((item: any) => {
                                                return (
                                                    <tr>
                                                        <td>
                                                            {item.ParentName}
                                                        </td>
                                                        <td>
                                                            {item.StudentName}
                                                        </td>

                                                        {/* <td>
                                                            {item.Status ==
                                                                1 && (
                                                                <span
                                                                    className={
                                                                        DetailClasses[
                                                                            "completed"
                                                                        ]
                                                                    }>
                                                                    Active
                                                                </span>
                                                            )}
                                                            {item.Status ==
                                                                2 && (
                                                                <span
                                                                    className={
                                                                        DetailClasses[
                                                                            "completed"
                                                                        ]
                                                                    }>
                                                                    Completed
                                                                </span>
                                                            )}
                                                            {item.Status ==
                                                                3 && (
                                                                <span
                                                                    className={
                                                                        DetailClasses[
                                                                            "cancelled"
                                                                        ]
                                                                    }>
                                                                    Cancelled
                                                                </span>
                                                            )}
                                                        </td> */}
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    <>                    <h3>Classes</h3>

                        <div ref={tabsRef} className={DetailClasses["Navigator"]}>
                            <button
                                className={activeTab === 1 ? DetailClasses["active"] : ""}
                                onClick={() => setActiveTab(1)}>
                                Pending
                            </button>
                            <button
                                className={activeTab === 5 ? DetailClasses["active"] : ""}
                                onClick={() => setActiveTab(5)}>
                                Awaiting Status
                            </button>
                            <button
                                className={activeTab === 2 ? DetailClasses["active"] : ""}
                                onClick={() => setActiveTab(2)}>
                                Completed
                            </button>
                            <button
                                className={activeTab === 3 ? DetailClasses["active"] : ""}
                                onClick={() => setActiveTab(3)}>
                                Cancelled
                            </button>
                        </div>

                        <div className={DetailClasses["Table"]}>

                            <table>
                                <thead>
                                    <tr>
                                        <th>Class</th>
                                        <th>Start Date Time</th>
                                        <th>End Time</th>
                                        <th>Duration</th>
                                        <th>Lesson Plan</th>
                                        <th>Created At</th>
                                        <th>Cancelled On</th>
                                        <th>Cancel Reason</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {scheduleClassesLoad ? (
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "center", padding: "2rem" }}>
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <Loader />
                                                </div>
                                            </td>
                                        </tr>
                                    ) : scheduleClasses && scheduleClasses.length > 0 ? (
                                        scheduleClasses.map((item: any, index: number) => {
                                            const cancelledOn = item.CancelledOn || item.CancelledAt || item.CancelDate || item.Cancelled_On || item.Cancelled_At || item.UpdatedAt;
                                            return (
                                                <tr
                                                    key={item.ScheduleClassID || index}
                                                    id={item.ScheduleClassID}
                                                    onClick={(e) => {
                                                        const id = e.currentTarget.getAttribute("id");
                                                        Navigate(`/Tutor/Classes/details?id=${id}`);
                                                    }}
                                                >
                                                    <td>{item.ClassLessonName}</td>
                                                    <td>
                                                        <Moment format="DD-MM-YYYY">
                                                            {new Date(item.Scheduled_StartDate)}
                                                        </Moment>
                                                        <br />
                                                        {String(item.Scheduled_StartTime)}
                                                    </td>
                                                    <td>{String(item.Scheduled_EndTime)}</td>
                                                    <td>{item.ClassDuration} Min</td>
                                                    <td style={{ wordWrap: "break-word", maxWidth: "200px" }}>
                                                        {item?.LessonPlans_Class && item.LessonPlans_Class.join(",")}
                                                        {item?.PartiallyCompleted?.IsPartiallyCompleted === 1 && (
                                                            <>
                                                                {item?.LessonPlans_Class?.length > 0 && ","}
                                                                {item?.PartiallyCompleted.LessonPlan}
                                                                ({item?.PartiallyCompleted.Slide})
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.CreatedAt ? (
                                                            <Moment format="DD-MM-YYYY">
                                                                {new Date(item.CreatedAt)}
                                                            </Moment>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.ClassStatus === 3 && cancelledOn ? (
                                                            <Moment format="DD-MM-YYYY">
                                                                {new Date(cancelledOn)}
                                                            </Moment>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                    <td
                                                        style={{
                                                            wordBreak: "break-word",
                                                            maxWidth: "8rem",
                                                        }}>
                                                        {item.Cancellation_Policy_Type === 'Is_After' ? ' Parent asked to cancel within 60 minutes' : item.Cancellation_Policy_Type === 'Is_Before' ? ' Parent asked to cancel before 60 minutes' : item.CancelReason}

                                                    </td>
                                                    <td>
                                                        {item.DisplayClassStatus === 1 ? (
                                                            <span className={DetailClasses["pending-stat"]}>
                                                                Pending
                                                            </span>
                                                        ) : item.DisplayClassStatus === 5 ? (
                                                            <span className={DetailClasses["awaiting-stat"]}>
                                                                Awaiting Status
                                                            </span>
                                                        ) : item.DisplayClassStatus === 2 ? (
                                                            <span className={DetailClasses["completed-stat"]}>
                                                                Completed
                                                            </span>
                                                        ) : (
                                                            <span className={DetailClasses["cancelled-stat"]}>
                                                                Cancelled By{" "}
                                                                {item.CancelledByType === 1
                                                                    ? "Admin"
                                                                    : item.CancelledByType === 2
                                                                        ? "RM"
                                                                        : item.CancelledByType === 3
                                                                            ? "Tutor"
                                                                            : item.CancelledByType === 4
                                                                                ? "Parent"
                                                                                : "SM"}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "center" }}>
                                                No Records Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                    {pagination && (
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1rem", backgroundColor: "white", border: "1px solid #ccc", borderTop: "none" }}>
                            <span style={{ fontSize: "14px", fontWeight: "500", color: "#555" }}>
                                Page {pagination.currentPage} of {pagination.totalPages} ({pagination.totalRecords} records)
                            </span>
                            <div style={{ display: "flex", gap: "0.5rem" }}>
                                <button
                                    disabled={!pagination.hasPrevPage}
                                    onClick={() => {
                                        setPage(prev => prev - 1);
                                        setTimeout(() => tabsRef.current?.scrollIntoView({ behavior: "smooth" }), 100);
                                    }}
                                    style={{
                                        padding: "0.5rem 1rem",
                                        border: "1px solid #ccc",
                                        backgroundColor: pagination.hasPrevPage ? "#fff" : "#f5f5f5",
                                        color: pagination.hasPrevPage ? "#333" : "#aaa",
                                        borderRadius: "4px",
                                        cursor: pagination.hasPrevPage ? "pointer" : "not-allowed"
                                    }}
                                >
                                    Previous
                                </button>
                                <button
                                    disabled={!pagination.hasNextPage}
                                    onClick={() => {
                                        setPage(prev => prev + 1);
                                        setTimeout(() => tabsRef.current?.scrollIntoView({ behavior: "smooth" }), 100);
                                    }}
                                    style={{
                                        padding: "0.5rem 1rem",
                                        border: "1px solid #ccc",
                                        backgroundColor: pagination.hasNextPage ? "#fff" : "#f5f5f5",
                                        color: pagination.hasNextPage ? "#333" : "#aaa",
                                        borderRadius: "4px",
                                        cursor: pagination.hasNextPage ? "pointer" : "not-allowed"
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Details;
